const sessionsConstants = {
  STORAGETOKENKEY: "sid",
};

export default sessionsConstants;
